module.exports = __webpack_public_path__ + "img/Captain.5fea9793.svg";